var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xh-wrap"
  }, [_c('myImg', {
    attrs: {
      "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner1.jpg"
    }
  }), _vm._v(" "), _c('myTab', {
    attrs: {
      "tab-list": _vm.tabList,
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle,
      "custom-event": "",
      "smallSize": ""
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), (_vm.activeIndex == 0) ? [_c('b-container', [_c('div', {
    staticClass: "text-left bold mt-40  fs-24"
  }, [_vm._v(_vm._s(_vm.$t("mediacenter.mediacontact")))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "item block-mb"
  }, [_c('div', {
    staticClass: "item-title fs-24 pl-20 mb-20 "
  }, [_vm._v("\n              " + _vm._s(_vm.$t("pagebottom.executive1")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v(_vm._s(_vm.$t('mediacenter.contactname') + _vm.$t('mediacenter.name1')))]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('mediacenter.contactphone'))), _c('a', {
    attrs: {
      "href": "tel:020-89138049"
    }
  }, [_vm._v("020-89138049")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:89138025"
    }
  }, [_vm._v("89138025")])]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_c('a', {
    attrs: {
      "href": "mailto:chenb@autoguangzhou.com.cn"
    }
  }, [_vm._v("E-mail：chenb@autoguangzhou.com.cn")])]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("\n                            "), _c('a', {
    attrs: {
      "href": "mailto:tangj@autoguangzhou.com.cn"
    }
  }, [_vm._v("tangj@autoguangzhou.com.cn")])])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "item block-mb"
  }, [_c('div', {
    staticClass: "item-title fs-24 pl-20 mb-20"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("pagebottom.sponsor4")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v(_vm._s(_vm.$t('mediacenter.contactname') + _vm.$t('mediacenter.name2')))]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('mediacenter.contactphone'))), _c('a', {
    attrs: {
      "href": "tel:010-010-63368188"
    }
  }, [_vm._v("010-63368188转504")])]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_c('a', {
    attrs: {
      "href": "mailto:heyingrui@auto-ccpit.org"
    }
  }, [_vm._v("E-mail：heyingrui@auto-ccpit.org")])]), _vm._v(" "), _c('div', {
    staticClass: "item-line fs-20"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('mediacenter.please')) + "\n              "), _c('a', {
    staticClass: "download",
    attrs: {
      "target": "_blank",
      "href": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/gzcz_apply_data.zip"
    }
  }, [_vm._v(_vm._s(_vm.$t('mediacenter.download')) + "\n              ")]), _vm._v("\n              " + _vm._s(_vm.$t('mediacenter.cooperation1')) + "\n            ")])])])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? [_c('h2', [_vm._v("暂未开通")])] : _vm._e(), _vm._v(" "), _c('page-footer')], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f19dfb72","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mediaCenter/index.vue
// module id = null
// module chunks = 